<template>
  <div class="kb-image-overlay">
    <slot>
      <h2 v-if="subtitle">{{ subtitle }}</h2>
      <h1 v-if="title">{{ title }}</h1>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'kb-image-overlay',
    props: {
      title: String,
      subtitle: String
    }
  }
</script>

<style lang="scss">
@import '../../../scss/_breakpoints';

.gallery-bar-container {
  pointer-events: all;
  display: flex;
  margin-top: 8px;

  & > div {
    padding: 15px 8px 15px 0px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__gallery-bar-hitbox {
    width: 100%;
    cursor: pointer;
    padding: 5px 0;

    &:hover {
      .kb-gallery-bar {
        background: #fff;
      }
    }
  }
}


.kb-image-overlay {
  background: rgba(0,0,0,0.6);
  border-radius: 7px;
  padding: 25px;
  color: #fff;
  height: 100%;
  width: 100%;

  @media screen and (max-width: $breakPointMobile) {
    padding: 15px;
    border-radius: 0;
    backdrop-filter: blur(10px);
    width: 100%;
  }

  h1 {
    font-family: 'Roboto Condensed Regular', 'Roboto Condensed', sans-serif;
    font-weight: normal;
    font-size: 36px;
    line-height: 41px;
    margin-top: 6px;
    color: #fff;

    @media screen and (max-width: $breakPointMobile) {
      font-size: 27px;
      line-height: 34px;
    }
  }

  h2 {
    font-family: 'Roboto Condensed Regular', 'Roboto Condensed', sans-serif;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    color: #fff;

    @media screen and (max-width: $breakPointMobile) {
      font-size: 14px;
    }
  }
}
</style>